<!-- h-full + flex column so the grid pane can flex-1 into the viewport. Without
     min-h-0 on the grid child, flexbox refuses to shrink below intrinsic content
     size and the ag-grid inside spills below the fold. -->
<div class="p-4 flex flex-col gap-4 h-full">

  <div class="flex items-center gap-3 flex-none">
    <h1 class="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      <i class="fa-solid fa-database text-app-teal-100"></i>Common Data
    </h1>
    <span class="text-xs text-gray-500 dark:text-gray-400 ml-2">
      Fleet-shared data sources — pick a source on the left to review or edit.
    </span>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-[260px_1fr] gap-4 flex-1 min-h-0">

    <!-- Left: data-source picker. flex-col + overflow-hidden so the inner
         ul (flex-1 + overflow-y-auto) scrolls internally when the source
         count exceeds viewport height instead of pushing the page. -->
    <div class="border border-gray-200 dark:border-[#434863] rounded bg-white dark:bg-app-black-100 overflow-hidden flex flex-col min-h-0">
      <div class="px-3 py-2 border-b border-gray-200 dark:border-[#434863] flex-none">
        <span class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">Sources</span>
      </div>
      <ul class="divide-y divide-gray-200 dark:divide-[#434863] flex-1 overflow-y-auto min-h-0">
        <li *ngFor="let s of sources; trackBy: trackByKey">
          <button
            class="w-full text-left px-3 py-2 hover:bg-gray-50 dark:hover:bg-app-blue-100/30 transition"
            [class.bg-app-blue-100]="active === s.key"
            (click)="select(s.key)">
            <div class="text-sm text-gray-900 dark:text-white flex items-center gap-2">
              <i class="{{ s.icon }} text-app-teal-100 w-4 text-center"></i>
              {{ s.label }}
            </div>
            <div class="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5 pl-6">
              {{ s.hint }}
            </div>
          </button>
        </li>
      </ul>
    </div>

    <!-- Right: source-specific pane. min-h-0 mirrors the parent so nested
         h-full panes (ag-grid in instrument-details) actually fill available
         vertical space. -->
    <div class="border border-gray-200 dark:border-[#434863] rounded bg-white dark:bg-app-black-100 overflow-hidden min-h-0">
      <app-github-symbol-lists *ngIf="active === 'github-symbol-lists'" (editDefinition)="editRegistry($event)"></app-github-symbol-lists>
      <app-symbol-lists-registry *ngIf="active === 'symbol-lists-registry'" [preselectName]="registryPreselect"></app-symbol-lists-registry>
      <app-instrument-details *ngIf="active === 'instrument-details'"></app-instrument-details>
      <app-index-constituents *ngIf="active === 'index-constituents'"></app-index-constituents>
      <app-tickers-master *ngIf="active === 'tickers-master'"></app-tickers-master>
      <app-mongo-explorer *ngIf="active === 'mongo-v2'" [stack]="'v2'"></app-mongo-explorer>
      <app-mongo-explorer *ngIf="active === 'mongo-v1'" [stack]="'v1'"></app-mongo-explorer>
    </div>

  </div>
</div>
